import React from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';

import { SignupPage } from 'components/SignupPage';
import { submitCreateAccountForm, showRequestResetPassword } from 'client/user';
import { useCurrentUserCtx } from 'contexts/CurrentUser';
import { usePartnerIds } from 'hooks/user/usePartnerIds';

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: data => {
    const {
      location: { search },
      fetchCurrentUser,
    } = ownProps;
    const { ref } = queryString.parse(search);
    // Passing isFromSignup=true to fetchCurrentUser() ensures mParticle
    // 'onboarding_completed' event is fired in callback
    return dispatch(
      submitCreateAccountForm(data, () => fetchCurrentUser(), {
        doAddToEmailList: true,
        ref,
      })
    );
  },
  onClickRequestResetPassword: () =>
    dispatch(showRequestResetPassword('Forgot Password')),
});

const SignUpPageContainerWithRedux = connect(
  null,
  mapDispatchToProps
)(SignupPage);

export default function SignUpPageWrapper(props) {
  const { fetchCurrentUser } = useCurrentUserCtx();
  const { setTrackOnboarding } = usePartnerIds();
  return (
    <SignUpPageContainerWithRedux
      {...props}
      fetchCurrentUser={() => {
        fetchCurrentUser();
        setTrackOnboarding('pending');
      }}
    />
  );
}
